import React, { Component } from "react";
import Intercom from "react-intercom";
import { connect } from "react-redux";
import { isLoggedIn } from "../../store/iam/selectors";
import { INTERCOM_APP_ID } from "../../config";
export class IntercomBubble extends Component {
  render() {
    return <div>{!this.props.isLoggedIn && <Intercom appID={INTERCOM_APP_ID} />}</div>;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    isLoggedIn: isLoggedIn(state)
  };
};

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IntercomBubble);
